import React from "react";

export default function ({data, order}) {
  return (
    <div className="col-xxl-6 pt-5">
      <div className="card card-flush py-4 flex-row-fluid">
        <div className="card-header">
          <div className="card-title">
            <h2>Order Details (#{order.id})</h2>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="table-responsive">
            <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
              <tbody className="fw-bold text-gray-600">
              <tr>
                <td className="text-muted">
                  <span className="d-flex align-items-center">
                    Date Added
                  </span>
                </td>
                <td className="fw-bolder text-end">
                  <span className="d-block mb-2">
                    {order?.created_at}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <span className="d-flex align-items-center">
                    Payment Method
                  </span>
                </td>
                <td className="fw-bolder text-end">
                  {data?.paymentMethods?.find(item => item.id === order.payment_method)?.name}
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <span className="d-flex align-items-center">
                    Status
                  </span>
                </td>
                <td className="fw-bolder text-end">
                  {data?.orderStatuses?.find(item => item.id === order.status)?.name}
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <span className="d-flex align-items-center">
                    Transaction ID
                  </span>
                </td>
                <td className="fw-bolder text-end">
                  {order.bank_order_id}
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <span className="d-flex align-items-center">
                    Payment provider
                  </span>
                </td>
                <td className="fw-bolder text-end">
                  {data?.paymentProviders?.find(item => item.id === order.payment_provider)?.name}
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <span className="d-flex align-items-center">
                    Delivery provider
                  </span>
                </td>
                <td className="fw-bolder text-end">
                  {order.delivery_provider}
                </td>
              </tr>
              {order.agreement && (
                <tr>
                  <td className="text-muted">
                    <span className="d-flex align-items-center">
                    Cashback Agreement
                    </span>
                  </td>
                  <td className="fw-bolder text-end">
                    {order.agreement ? 'Yes' : "No"}
                  </td>
                </tr>
              )}
              {
                order?.coupon && (
                  <tr>
                    <td className="text-muted">
                      <span className="d-flex align-items-center">
                        Voucher
                      </span>
                    </td>
                    <td className="fw-bolder text-end">
                      {order.coupon}
                    </td>
                  </tr>
                )
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
